import Sidebar from "../layout/Sidebar";
import Topbar from "../layout/Topbar";
import CreateJobFormNew from "../components/NewCreateForm";
import { useState } from "react";

function CreateJobNew() {
  const [showSidebar, setShowSidebar] = useState(false);

  return (
    <div className="app">

      {/* Sidebar */}
      <Sidebar
        show={showSidebar}
        closeSidebar={() => setShowSidebar(false)}
      />

      {/* Main */}
      <div className="main">
        <Topbar toggleSidebar={() => setShowSidebar(true)} />

        <div className="page">
          <CreateJobFormNew />
        </div>
      </div>
    </div>
  );
}

export default CreateJobNew;